
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 8a2 2 0 10-1.909-1.4L8.968 9.723 6.995 6.92a1 1 0 00-1.525-.132l-2.7 2.7A2 2 0 103.987 11.1l2.058-2.058 1.973 2.804a1 1 0 001.525.132l4.025-4.025c.14.03.284.047.433.047z","fill":"#22D5C8"}})])
          )
        }
      }
    